import { SummaryReportQueryController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows summary report of selected period.
 * @example
 * ```html
 * <salaxy-summary-report-query></salaxy-summary-report-query>
 * ```
 */
export class SummaryReportQuery extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {};

    /** Uses the SummaryReportQueryController */
    public controller = SummaryReportQueryController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/report/SummaryReportQuery.html";

}
